const timesheetActivityTypes = {
    CASE_ACTIVITY: 0,
    USER_ACTIVITY: 1
}

export default timesheetActivityTypes